import axios from "axios";
import React, { Component } from "react";
import { configuration } from "../appConfig";
import RequestLoader from "../spinner";


export default class NewCarDentPositionTable extends Component {
  state = {
    words: {},
    lang: "En",
    DentPos: [],
  };

  componentDidMount() {
    this.getData();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.part!== this.props.part) {
      this.getData();
    }
  }
  getData = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url = `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`;
    try {
      const res = await axios.get(url);
      if (res && res.data) {
        this.getPartCordination(res.data.Dents);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  getPartCordination = (Dents) => {
    const { part } = this.props;
    const directions =
      Dents &&
      Dents.length > 0 &&
      Dents.find((Name) => {
        return Name.Part === part;
      });
    this.setState({ DentPos: directions.DentPos });
  };
  roundUpToNearest10 = (value) => {
    return Math.ceil(value / 10) * 10;
  };

  render() {
    const { DentPos } = this.state;
    const { imageIndex, lang, loader } = this.props;
    const partnerId = localStorage.getItem("partnerId");

    let totalSum = 0;
    DentPos && Array.isArray(DentPos) && DentPos.length > 0 && DentPos.forEach((r) => {
      const Diamm = Array.isArray(r.DiaMm) ? r.DiaMm[imageIndex] : r.DiaMm;
      totalSum += parseFloat(Diamm);
    });
    const total = this.roundUpToNearest10(totalSum / (DentPos.length + 1));
    return (
      <div className="row m-0 text-muted hide-report car-dents-position-table">
        <div className="table-responsive">
          <table className="table table-bordered table-striped dent-table-2d">
            <thead>
              <tr style={{ textAlign: "center" }}>
                <th>Sn</th>
                <th>X</th>
                <th>Y</th>
                <th>{lang("Size")}</th>
              </tr>
            </thead>
            {loader ? (
              <RequestLoader size="60px" />
            ) : (
              <tbody>
              {DentPos && DentPos.length > 0 ? (
                DentPos.map((r, i) => {
                  const diaMmValue = Array.isArray(r.DiaMm)
                    ? partnerId === "10-200410-2" || partnerId === "10-200410"
                      ? parseFloat(r.DiaMm[imageIndex] * 0.0393701).toFixed(2)
                      : parseInt(r.DiaMm[imageIndex])
                    : partnerId === "10-200410-2" || partnerId === "10-200410"
                    ? parseFloat(r.DiaMm * 0.0393701).toFixed(2)
                    : parseInt(r.DiaMm);

                  const xValue = Array.isArray(r.X)
                    ? parseInt(r.X[imageIndex])
                    : parseInt(r.X);
                  const yValue = Array.isArray(r.Y)
                    ? parseInt(r.Y[imageIndex])
                    : parseInt(r.Y);

                  return (
                    <tr key={i}>
                      <td style={{ textAlign: "center" }}>{i + 1}</td>
                      <td>{xValue}</td>
                      <td>{yValue}</td>
                      <td>{diaMmValue}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4}>{lang("No Dent Data Found")}</td>
                </tr>
              )}
              {DentPos && DentPos.length ? (
                <tr>
                  <td colSpan={3} style={{ textAlign: "right" }}>
                    Total:
                  </td>
                  <td>{total}</td>
                </tr>
              ) : null}
            </tbody>
            )}
            
          </table>
        </div>
      </div>
    );
  }
}
